var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCancel({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    display: "block",
    className: "vkuiIcon vkuiIcon--16 vkuiIcon--w-16 vkuiIcon--h-16 vkuiIcon--cancel_circle_16",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    style: {
      width: 16,
      height: 16
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    id: "cancel_circle_16"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0m2.466 4.26L8 6.727 5.536 4.26a.9.9 0 1 0-1.273 1.273l2.465 2.468-2.465 2.469a.9.9 0 0 0 1.273 1.273L8 9.275l2.466 2.468a.9.9 0 1 0 1.273-1.273L9.272 8.001l2.467-2.468a.9.9 0 1 0-1.273-1.273"
  })))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cancel_circle_16",
    style: {
      fill: "currentcolor"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.9cd6fcfd8136b4cf05a07d176221d9be.svg";
export { ForwardRef as ReactComponent };